module.exports = __webpack_public_path__ + "img/giphy.5d434b3e.gif";